module.exports = __webpack_public_path__ + "img/angry.f2f24ead.gif";